import { useMemo } from "react";
import { useSelector } from "react-redux";
import useUserAuthentication from "../../_hooks/useUserAuthentication";
import { OrganizationType } from "../../_statics/OrganizationType";

export const useUserDropdownUtils = () => {
    const clientReducer = useSelector((state) => state.client);
    const user = useSelector((state) => state.authentication.user);
    const { isSuperUser, isInAgency, selectedOrganization } = useUserAuthentication();

    const isTaxAgency = useMemo(
        () =>
            user &&
            user.selectedOrganization &&
            user.selectedOrganization.organizationType === OrganizationType.TAX_AGENCY,
        [user]
    );

    const userDropdownItems = useMemo(() => {
        let items = [
            {
                name: "Administration",
                url: "/adminarea",
                dataCy: "user-admin-button",
                icon: "fas fa-user-tie",
                hidden: !(isSuperUser || isInAgency),
                index: 1,
            },
            {
                name: "Account und Abrechnung",
                url: "/organization",
                dataCy: "user-company-button",
                icon: "fas fa-building",
                index: 3,
            },
            {
                name:
                    "API Verbindungen" +
                    (clientReducer && clientReducer.clients ? ` (${clientReducer.clients.length})` : ""),
                url: "/clients",
                dataCy: "user-clients-button",
                icon: "fas fa-plug-circle-bolt",
                hidden: isTaxAgency,
                index: 4,
            },
            {
                name: "Logout",
                url: "/dologout",
                dataCy: "logout-button",
                icon: "fas fa-lock",
                index: 5,
            },
        ];

        if (selectedOrganization) {
            items.push({
                name: `Administration (${selectedOrganization.name})`,
                url: `/adminarea/organization/${selectedOrganization.externalUUID}`,
                dataCy: "user-admin-button",
                icon: "fas fa-user-tie",
                hidden: !(isSuperUser || isInAgency),
                index: 2,
            });
        }

        // Steuerkanzlei V6 audit log (#41918) — visible ONLY to pathway Super Users (read-only) and ONLY when
        // the selected organization is a Steuerkanzlei (tax agency).
        if (isSuperUser && isTaxAgency) {
            items.push({
                name: "Audit Log",
                url: "/adminarea/kanzlei-audit",
                dataCy: "kanzlei-audit-nav-button",
                icon: "fa fa-shield-alt",
                index: 2.5,
            });
        }

        return items;
    }, [clientReducer, isInAgency, isSuperUser, isTaxAgency, selectedOrganization]);

    return {
        userDropdownItems,
    };
};
